export default __webpack_public_path__ + "static/media/MyTeamActiveIcon.50c63eec.svg";